import React, { useState, useEffect } from "react";
import Header from "../../layout/header";
import MyTeam from "../../assets/landingPage-icon/MyTeam.svg";
import MyTeamHover from "../../assets/landingPage-icon/MyTeams-hover.svg";
import MyTeamClick from "../../assets/landingPage-icon/MyTeam-click.svg";
import Customers from "../../assets/landingPage-icon/Customers.svg";
import CustomersHover from "../../assets/landingPage-icon/Customers-hover.svg";
import CustomersClick from "../../assets/landingPage-icon/Customers-click.svg";
import Planogram from "../../assets/landingPage-icon/Planogram.svg";
import PlanogramHover from "../../assets/landingPage-icon/Planogram-hover.svg";
import PlanogramClick from "../../assets/landingPage-icon/Planogram-click.svg";
import Territory from "../../assets/landingPage-icon/Territory.svg";
import TerritoryHover from "../../assets/landingPage-icon/Territory-hover.svg";
import TerritoryClick from "../../assets/landingPage-icon/Territory-click.svg";
import Print from "../../assets/landingPage-icon/Print.svg";
import PrintHover from "../../assets/landingPage-icon/Print-hover.svg";
import Finance from "../../assets/landingPage-icon/Finanace.svg";
import FinanceHovar from "../../assets/landingPage-icon/Finance-hover.svg";
import AdminClick from "../../assets/landingPage-icon/Admin-click.svg";
import URL_MAPPING from "../../routes/constants";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import getSliderImages from "../../api/landing";
import Carousel from "../../components/Carousel";
import { getUserInfo } from "../..//utility";

/**
 * API often returns `{ images: [...] }` or nested `data`. Always produce a real array for Carousel.
 */
const normalizeSliderImages = (body: unknown): any[] => {
  if (body == null) return [];
  if (Array.isArray(body)) return body;
  if (typeof body === "object") {
    const o = body as Record<string, unknown>;
    if (Array.isArray(o.images)) return o.images;

    // Nested e.g. { data: { images: [...] } }
    if (o.data != null && typeof o.data === "object" && !Array.isArray(o.data)) {
      return normalizeSliderImages(o.data);
    }
  }
  return [];
};

const Index: React.FC = () => {
  const navigate = useNavigate();
  const [activeButton, setActiveButton] = useState<number | null>(null);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [clickedButton, setClickedButton] = useState<number | null>(null);
  const [images, setSliderImages] = useState<any>([]);
  const { t } = useTranslation();

  let userRole: any = getUserInfo();
  let buttonData: any[] = [];

  // Hardcoded EMPI IDs that should also see the B2B tile
  const B2B_ALLOWED_EMPI_IDS = ["105950", "106097", "105288", "105553", "106295", "105673"];

  // Hardcoded EMPI IDs that can use the LMD Territory tile
  const LMD_TERRITORY_ALLOWED_EMPI_IDS = ["AV0001", "102910", "105337", "103257"];

  // Hardcoded EMPI IDs that should also see the SDR PS tile
  const SDR_PS_ALLOWED_EMPI_IDS: string[] = ["105673"];

  // Hardcoded EMPI IDs that should ONLY see the Finance tile on the landing page
  const FINANCE_ALLOWED_EMPI_IDS: string[] = ["100036", "102910", "AV0001"];

  // Hardcoded EMPI IDs that can see the Planning tile
  const PLANNING_ALLOWED_EMPI_IDS: string[] = ["103407", "106295", "102903", "102910", "AV0001"];

  const userTeams = userRole?.teams || [];
  const hasSales = userTeams.includes("SALES");
  const hasDelivery = userTeams.includes("DELIVERY");
  const superadmin = getUserInfo()?.superadmin || false;
  const currentEmpId = (userRole?.emp_id ?? userRole?.employee_id ?? "")?.toString?.().trim() || "";
  const canSeeB2B =
    superadmin || B2B_ALLOWED_EMPI_IDS.includes(currentEmpId);
  const canUseLmdTerritory = LMD_TERRITORY_ALLOWED_EMPI_IDS.includes(currentEmpId);
  const canSeeSdrPs =
    hasSales || SDR_PS_ALLOWED_EMPI_IDS.includes(currentEmpId);
  const canSeePlanning = PLANNING_ALLOWED_EMPI_IDS.includes(currentEmpId);
  const canSeeFinance = FINANCE_ALLOWED_EMPI_IDS.includes(currentEmpId);
  const isFinanceOnlyUser = canSeeFinance && !hasSales && !hasDelivery;

  if (isFinanceOnlyUser) {
    buttonData = [
      {
        id: 6,
        label: t("Landing.print"),
        icons: { default: Print, hover: PrintHover, click: AdminClick },
        url: URL_MAPPING.DEPOSITREPORT,
        disabled: false,
        name: "Print",
        section: "Print",
      },
      {
        id: 7,
        label: t("Landing.finance"),
        icons: { default: Finance, hover: FinanceHovar, click: AdminClick },
        url: URL_MAPPING.DEPOSITREPORT,
        disabled: false,
        name: "Finance",
        section: "Finance",
      },
    ];
  } else if (
    hasSales ||
    hasDelivery ||
    canUseLmdTerritory ||
    superadmin ||
    canSeeB2B ||
    canSeeFinance ||
    SDR_PS_ALLOWED_EMPI_IDS.includes(currentEmpId) ||
    PLANNING_ALLOWED_EMPI_IDS.includes(currentEmpId)
  ) {
    buttonData = [

      ...(hasSales
        ? [
          {
            id: 1,
            label: t("Landing.myTeam"),
            icons: { default: MyTeam, hover: MyTeamHover, click: MyTeamClick },
            url: URL_MAPPING.ANALYTICS,
            disabled: false,
            name: "My Team",
            section: "My Team",
          },
        ]
        : []),
      ...(hasDelivery
        ? [
          {
            id: 8,
            label: t("Landing.lmd"),
            icons: { default: MyTeam, hover: MyTeamHover, click: MyTeamClick },
            url: URL_MAPPING.DELIVERYDASHBOARD,
            disabled: false,
            name: "Last Mile Delivery",
            section: "Delivery_My_Team",
          },


        ]
        : []),
      ...(hasSales
        ? [
          {
            id: 9,
            label: t("Landing.supervisor"),
            icons: { default: MyTeam, hover: MyTeamHover, click: MyTeamClick },
            url: URL_MAPPING.SUPERVISORDASHBOARD,
            disabled: false,
            name: "Supervisor",
            section: "Supervisor",
          },
        ]
        : []),
      ...(canSeeSdrPs
        ? [
          {

            id: 9,
            label: t("Landing.SDR"),
            icons: { default: MyTeam, hover: MyTeamHover, click: MyTeamClick },
            url: URL_MAPPING.MAPVIEW,
            disabled: false,
            name: "SDR",
            section: "SDR",
          },

        ]
        : []),



      ...((hasSales || canUseLmdTerritory)
        ? [
          {
            id: 5,
            label: t("Landing.territory"),
            icons: {
              default: Territory,
              hover: TerritoryHover,
              click: TerritoryClick,
            },
            url: URL_MAPPING.TERRITORYMAPVIEW,
            disabled: !canUseLmdTerritory,
            name: "Territory",
            section: "Territory",
          },
        ]
        : []),

      ...(canSeeFinance
        ? [
          {
            id: 6,
            label: t("Landing.print"),
            icons: { default: Print, hover: PrintHover, click: AdminClick },
            url: URL_MAPPING.DEPOSITREPORT,
            disabled: false,
            name: "Print",
            section: "Print",
          },
          {
            id: 7,
            label: t("Landing.finance"),
            icons: { default: Finance, hover: FinanceHovar, click: AdminClick },
            url: URL_MAPPING.DEPOSITREPORT,
            disabled: false,
            name: "Finance",
            section: "Finance",
          },
        ]
        : []),
      ...(canSeePlanning
        ? [
          {
            id: 11,
            label: t("Landing.planning", "Planning"),
            icons: {
              default: Planogram,
              hover: PlanogramHover,
              click: PlanogramClick,
            },
            url: URL_MAPPING.ROUTE_PLANNING_GENERATE,
            disabled: false,
            name: "Planning",
            section: "Planning",
          },
        ]
        : []),
      ...(superadmin
        ? [
          {
            id: 9,
            label: "Admin",
            icons: {
              default: Finance,
              hover: FinanceHovar,
              click: AdminClick,
            },
            url: URL_MAPPING.ADMINPANEL,
            disabled: false,
            name: "Admin",
            section: "admin_panel",
          },

        ]
        : []),
      ...(canSeeB2B
        ? [
          {
            id: 10,
            label: "B2B",
            icons: {
              default: Finance,
              hover: FinanceHovar,
              click: AdminClick,
            },
            url: URL_MAPPING.B2BDASHBOARD,
            disabled: false,
            name: "B2B",
            section: "B2B",
          },
        ]
        : [])
    ];

    // [

    //   //   {
    //   //     id: 2,
    //   //     label: t("Landing.planogram"),
    //   //     icons: {
    //   //       default: Planogram,
    //   //       hover: PlanogramHover,
    //   //       click: PlanogramClick,
    //   //     },
    //   //     url: URL_MAPPING.PLANOGRAM,
    //   //     disabled: false,
    //   //     name: "Planogram",
    //   //     section: "Delivery_Planogram",
    //   //   },
    //   //   {
    //   //     id: 3,
    //   //     label: t("Landing.print"),
    //   //     icons: { default: Print, hover: PrintHover, click: AdminClick },
    //   //     url: URL_MAPPING.DEPOSITREPORT,
    //   //     disabled: false,
    //   //     name: "Print",
    //   //     section: "Delivery_Print",
    //   //   },
    //   // ];
    // ]
  }


  const handleButtonClick = (button: any) => {
    localStorage.setItem("section", button.section);
    navigate(button.url);
  };

  const getSliderImagesData = async () => {
    try {
      const res = await getSliderImages();
      const raw = res?.data;
      const list = normalizeSliderImages(raw);
      setSliderImages(list);
    } catch (error) {
      console.error("Failed to load slider images:", error);
      setSliderImages([]);
    }
  };
  useEffect(() => {
    localStorage.setItem("section", "default");
  }, []);

  useEffect(() => {
    getSliderImagesData();
  }, []);




  // const handleToggle = (mode: "SALES" | "DELIVERY") => {
  //   setToggleMode(mode);
  //   localStorage.setItem("toggleMode", mode);
  // };

  return (
    <div>
      <div className="w-full  fixed z-50 ">
        <Header hide={true} />
      </div>
      <div className=" flex flex-col items-center py-4 pt-[54px]">
        <Carousel images={images} />
        <hr className="w-[calc(100vw-50px)] border-t-2 border-gray-300  mb-6 relative" />
        <div className="grid grid-cols-2 md:flex md:justify-center md:gap-16  gap-4 w-full max-w-7xl pb-[100px]">

          {buttonData?.map((button, index) => {
            let iconSrc = button.icons.default;
            if (clickedButton === index) iconSrc = button.icons.click;
            else if (activeButton === index) iconSrc = button.icons.hover;

            return (
              <button
                key={button.id}
                className={`group flex flex-col items-center cursor-pointer mt-12 justify-center  ${button.disabled
                  ? "opacity-50 cursor-not-allowed"
                  : "hover:text-purple transition-colors"
                  }`}
                onMouseEnter={() => setActiveButton(index)}
                onMouseLeave={() => setActiveButton(null)}
                onClick={() => handleButtonClick(button)}
                disabled={button.disabled}
              >
                <img
                  src={iconSrc}
                  alt={button.label}
                  className={`${button.disabled
                    ? ""
                    : "transition-transform duration-100 ease-in-out hover:scale-110"
                    } w-32 h-32 mb-2 transform `}
                />
                <div className="transition-colors group:hover:text-purple">
                  <b>{button.label}</b>
                </div>
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Index;
